import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  computed,
  input,
} from '@angular/core';
import type { EventqSiteOverviewField } from '../site-overview-details/site-overview-details';

export type EventqSiteFieldsLayout = 'grid' | 'stacked';

@Component({
  selector: 'eventq-site-fields',
  templateUrl: './site-fields.html',
  styleUrl: './site-fields.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.aria-busy]': 'loading() ? "true" : null',
  },
})
export class EventqSiteFields {
  readonly fields = input.required<readonly EventqSiteOverviewField[]>();
  readonly loading = input(false, { transform: booleanAttribute });
  /** `stacked` is one field per row. Both layouts wrap long values. */
  readonly layout = input<EventqSiteFieldsLayout>('grid');

  readonly stacked = computed(() => this.layout() === 'stacked');

  readonly hasContent = computed(() => this.fields().length > 0);
}
